import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "common": {
            "error": "Error",
            "unknown_error": "Unknown Error",
            "confirm_delete": "Are you sure you want to delete this?",
            "cancel": "Cancel",
            "save": "Save",
            "delete": "Delete",
            "confirm": "Confirm",
            "required": "Required",
            "invalid_format": "Invalid Format",
            "create": "Create",
            "reset": "Reset",
            "grant": "Grant",
            "deny": "Deny",
            "default": "Default",
            "none": "None"
          },
          "settings": {
            "permissions": {
              "title": "Admin Screen Permissions",
              "description": "Manage roles and permissions for administrators.",
              "role_list": "Role List",
              "add_role": "Add Role",
              "add_role_description": "Create a new custom role for your club.",
              "system_role": "System Role",
              "custom_role": "Custom Role",
              "select_role_prompt": "Select a role to view permissions.",
              "role_created": "Role created successfully.",
              "role_deleted": "Role deleted successfully.",
              "saved": "Permissions saved.",
              "fetch_failed": "Failed to fetch permissions.",
              "create_role_title": "Create New Role",
              "role_name": "Role ID (Internal)",
              "role_display_name": "Display Name",
              "role_identifier": "Role Identifier",
              "role_identifier_help": "Must be lowercase, numbers, and underscores only.",
              "role_name_placeholder": "e.g. weekend_staff",
              "role_display_name_placeholder": "e.g. Weekend Staff",
              "system_role_warning": "Permissions of system roles are common across all clubs and should be handled with care.",
              "no_actions": "No specific actions for this menu.",
              "read_only": "Read Only",
              "inherited": "Inherited",
              "parent_role": "Base Role (Parent)",
              "tabs": {
                "roles": "Role Management",
                "staff": "Staff Overrides"
              },
              "staff_list": "Staff List",
              "select_staff_prompt": "Select a staff member to manage overrides.",
              "overrides_saved": "Overrides saved successfully.",
              "overrides_fetch_failed": "Failed to fetch overrides."
            }
          }
        }
      },
      ko: {
        translation: {
          "common": {
            "error": "오류",
            "unknown_error": "알 수 없는 오류",
            "confirm_delete": "정말 삭제하시겠습니까?",
            "cancel": "취소",
            "save": "저장",
            "delete": "삭제",
            "confirm": "확인",
            "required": "필수 입력 항목입니다",
            "invalid_format": "올바르지 않은 형식입니다",
            "create": "생성",
            "reset": "초기화",
            "grant": "허용",
            "deny": "차단",
            "default": "기본값",
            "none": "없음"
          },
          "settings": {
            "permissions": {
              "title": "관리자 화면 권한",
              "description": "관리자 역할 및 권한을 관리합니다.",
              "role_list": "역할 목록",
              "add_role": "역할 추가",
              "add_role_description": "클럽에서 사용할 새로운 사용자 정의 역할을 생성합니다.",
              "system_role": "시스템 역할",
              "custom_role": "사용자 정의 역할",
              "select_role_prompt": "권한을 설정할 역할을 선택하세요.",
              "role_created": "역할이 생성되었습니다.",
              "role_deleted": "역할이 삭제되었습니다.",
              "saved": "권한이 저장되었습니다.",
              "fetch_failed": "권한 정보를 불러오는데 실패했습니다.",
              "create_role_title": "새 역할 만들기",
              "role_name": "역할 ID (영문/숫자)",
              "role_display_name": "표시 이름",
              "role_identifier": "역할 식별자 (영문)",
              "role_identifier_help": "소문자, 숫자, 언더바(_)만 사용 가능합니다.",
              "role_name_placeholder": "예: weekend_staff",
              "role_display_name_placeholder": "예: 주말 스탭",
              "system_role_warning": "시스템 역할의 권한 변경은 전체 지점에 영향을 줄 수 있으므로 주의가 필요합니다.",
              "no_actions": "이 메뉴에 대한 세부 액션 권한이 없습니다.",
              "read_only": "조회 전용",
              "inherited": "상속됨",
              "parent_role": "상속받을 역할 (부모)",
              "tabs": {
                "roles": "역할 관리",
                "staff": "관리자 화면 권한 설정"
              },
              "staff_list": "직원 목록",
              "select_staff_prompt": "예외 설정을 관리할 직원을 왼쪽에서 선택하세요.",
              "overrides_saved": "예외 설정이 저장되었습니다.",
              "overrides_fetch_failed": "예외 설정을 불러오는 데 실패했습니다."
            }
          }
        }
      }
    },
    lng: "ko", // Default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
